import React from 'react';
import { footer, heroData } from '../data/mock';
import { MessageCircle, ArrowUp } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const whatsappLink = `https://wa.me/${heroData.whatsappNumber.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(heroData.whatsappMessage)}`;

  return (
    <footer className="bg-[#333333] text-[#FFFEF8]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="mb-6 bg-white/10 p-3 inline-block rounded">
              <img
                src={footer.logoImage}
                alt="ETERRNAL"
                className="h-14 w-auto object-contain"
              />
            </div>
            <p className="text-sm text-[#BCBBB4] leading-relaxed max-w-md mb-8">
              {footer.tagline}
            </p>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm text-[#FFFEF8] hover:text-[#6B8F71] transition-colors duration-300"
            >
              <MessageCircle className="w-4 h-4" />
              {footer.contact.whatsapp}
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-medium tracking-wide mb-6 text-[#FFFEF8]">
              Quick Links
            </h4>
            <nav className="space-y-4">
              {footer.links.map((link) => (
                <button
                  key={link.label}
                  onClick={() => scrollToSection(link.href)}
                  className="block text-sm text-[#BCBBB4] hover:text-[#FFFEF8] transition-colors duration-300"
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-medium tracking-wide mb-6 text-[#FFFEF8]">
              Get In Touch
            </h4>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-6 py-3 border border-[#FFFEF8] text-[#FFFEF8] text-sm font-medium hover:bg-[#FFFEF8] hover:text-[#333333] transition-all duration-300"
            >
              <MessageCircle className="w-4 h-4" />
              WhatsApp
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-[#4A4A4A] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#BCBBB4]">
            {footer.copyright}
          </p>
          <button
            onClick={scrollToTop}
            className="flex items-center gap-2 text-xs text-[#BCBBB4] hover:text-[#FFFEF8] transition-colors duration-300"
          >
            Back to top
            <ArrowUp className="w-4 h-4" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
